var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.125 26V13C34.1244 12.4301 33.974 11.8703 33.6888 11.3769C33.4035 10.8835 32.9936 10.4737 32.5 10.1887L21.125 3.68875C20.6309 3.4035 20.0705 3.25333 19.5 3.25333C18.9295 3.25333 18.3691 3.4035 17.875 3.68875L6.5 10.1887C6.00643 10.4737 5.59647 10.8835 5.31125 11.3769C5.02603 11.8703 4.87558 12.4301 4.875 13V26C4.87558 26.5699 5.02603 27.1297 5.31125 27.6231C5.59647 28.1165 6.00643 28.5263 6.5 28.8112L17.875 35.3112C18.3691 35.5965 18.9295 35.7467 19.5 35.7467C20.0705 35.7467 20.6309 35.5965 21.125 35.3112L32.5 28.8112C32.9936 28.5263 33.4035 28.1165 33.6888 27.6231C33.974 27.1297 34.1244 26.5699 34.125 26Z",
    stroke: "#3E8DE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31375 11.31L19.5 19.5163L33.6862 11.31",
    stroke: "#3E8DE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 35.88V19.5",
    stroke: "#3E8DE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.a46835c363ca28ebbc4710fb8be09bf5.svg";
export { ForwardRef as ReactComponent };